import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';

import { PVI_NO_STYLES_CLASSNAME } from 'utils/helpers/inclusion';
import styles from './styles.module.scss';

const ExtraControls = ({ trackSrc, copyWidgetCode }) => {
	const handleCopyKeydown = (event) => {
		if (event.key === 'Enter') {
			copyWidgetCode();
		}
	};
	return (
		<div className={styles.ExtraControls}>
			<a
				href={trackSrc}
				target="_blank"
				rel="noopener"
				type="button"
				className={styles.ExtraControls__Button}
				aria-label="Скачать аудиоверсию"
			>
				<Icon
					icon="audio-open"
					className={styles.ExtraControls__Icon_open}
					useClassName={PVI_NO_STYLES_CLASSNAME}
				/>
			</a>
			{!!copyWidgetCode && (
				<button
					type="button"
					className={styles.ExtraControls__Button}
					onClick={copyWidgetCode}
					onKeyDown={handleCopyKeydown}
					aria-label="Встроить код на сайт"
				>
					<Icon
						icon="audio-copy"
						className={styles.ExtraControls__Icon_copy}
						useClassName={PVI_NO_STYLES_CLASSNAME}
					/>
				</button>
			)}
		</div>
	);
};

ExtraControls.propTypes = {
	copyWidgetCode: PropTypes.func,
	trackSrc: PropTypes.string.isRequired
};

export default ExtraControls;
